import { c as createColorConfigPlugin } from "./create-color-config-plugin-1fc09863.mjs";
import { d as defineVuesticPlugin } from "../../vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../vue-plugin/utils/global-properties-9524ee5b.mjs";
const ColorConfigPlugin = defineVuesticPlugin((config) => ({
  install(app) {
    defineGlobalProperty(app, "$vaColorConfig", createColorConfigPlugin(app, config));
  }
}));
export {
  ColorConfigPlugin as C
};
//# sourceMappingURL=index-322fa67f.mjs.map
